import React, { useState } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import MyContext from "./StoreContext";

const Automation = React.lazy(() => import("./Automation/Automation"));
export const URL_BASE = "https://static.wholemeaning.com/demo";

/**
 * Aqui tenemos la definicion e inicializacion de todos los valores
 * del contexto y una funcion que tambien se la pasamos al proveedor
 * para poder actualizar dichos valores
 */
const App = () => {
  const [industry, setIndustry] = useState("");
  const updateIndustry = (industry: string) => {
    setIndustry(industry);
  };

  const [channel, setChannel] = useState("");
  const updateChannel = (channel: string) => {
    setChannel(channel);
  };

  const [message, setMessage] = useState("");
  const updateMessage = (message: string) => {
    setMessage(message);
  };

  const [platform, setPlatform] = useState("");
  const updatePlatform = (platform: string) => {
    setPlatform(platform);
  };

  const [showResponse, setShowResponse] = useState(false);
  const updateShowResponse = (showResponse: boolean) => {
    setShowResponse(showResponse);
  };

  const [showPlatform, setShowPlatform] = useState(false);
  const updateShowPlatform = (showPlatform: boolean) => {
    setShowPlatform(showPlatform);
  };

  const [openModal, setOpenModal] = useState(false);
  const updateOpenModal = (showPlatform: boolean) => {
    setOpenModal(showPlatform);
  };

  return (
    <div className='App'>
      <MyContext.Provider
        value={{
          industry,
          updateIndustry,
          channel,
          updateChannel,
          message,
          updateMessage,
          platform,
          updatePlatform,
          showResponse,
          updateShowResponse,
          showPlatform,
          updateShowPlatform,
          openModal,
          updateOpenModal,
        }}
      >
        <Header />
        <Routes>
          <Route
            path='/'
            element={
              <React.Suspense fallback={<div>Loading...</div>}>
                <Automation />
              </React.Suspense>
            }
          />
        </Routes>
      </MyContext.Provider>
    </div>
  );
};

export default App;
